import { inject } from "@angular/core";
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { NGXLogger } from "ngx-logger";
import { AUTH_SVC } from "@company-box/services";

export const bearerTokenHeaderInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const authService = inject(AUTH_SVC);
  const logger = inject(NGXLogger);
  const token = authService.getToken();
  if (!token?.accessToken) {
    logger.trace("proceeding without auth token");
    return next(req);
  } else {
    return next(req.clone({ setHeaders: { Authorization: "Bearer " + token!.accessToken } }));
  }
};
